import React from "react";

function About() {
  return (
    <main>
      {/* Breadcrumb Section */}
      <section className="page_breadcrumb" data-aos="fade-up">
        <div className="container">
          <div className="breadcrumb_content centred">
            <h1 className="breadcrumb_title">About Us</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>About Us</li>
            </ul>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about_section_three">
        <div className="container">
          <div className="row">
            {/* Right Content */}
            <div className="col-xl-7 col-lg-7 col-md-12">
              <div
                className="about_right_content"
                data-aos="fade-left"
                data-aos-duration="500"
              >
                <div className="section_title">
                  <h2>About Us</h2>
                  <p>
                    Eco Mantra Capital is a financial technology-driven firm
                    specializing in algorithmic trading solutions, portfolio
                    management, and strategic investment partnerships. We
                    provide advanced algo trading software on both rental and
                    sale basis, designed to deliver efficient, disciplined, and
                    emotion-free trading execution.
                  </p>
                  <p>
                    Our team comprises experienced fund managers, professional
                    traders, fundamental and technical analysts, and skilled
                    software developers with deep expertise in both domestic and
                    global financial markets. We combine financial intelligence
                    with cutting-edge technology to deliver consistent and
                    optimized trading solutions.
                  </p>
                </div>
              </div>
            </div>

            {/* Left Image */}
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div
                className="about_left_image pe-0"
                data-aos="fade-right"
                data-aos-duration="500"
              >
                <figure>
                  <img
                    src="/images/resource/about-us.png"
                    alt="About Eco Mantra Capital"
                    style={{ borderRadius: "10px" }}
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section
        className="service_section pt-5 pb-5"
        data-aos="fade-up"
        data-aos-duration="400"
      >
        <div className="circle_one"></div>
        <div className="circle_two"></div>
        <div className="container">
          <div className="section_title light centred">
            <h2 className="text-white">Our Services</h2>
          </div>
          <div className="row justify-content-center">
            {[
              {
                title: "Algorithmic Trading Software",
                desc: "We offer a wide range of customized and ready-to-deploy algo trading solutions across multiple asset classes and exchanges. Our software is available on rental as well as purchase basis.",
              },
              {
                title: "Portfolio Management Services",
                desc: "We assist clients in managing their trading portfolios using systematic, rule-based strategies aimed at reducing emotional bias and improving execution efficiency.",
              },
              {
                title: "Account Handling Assistance",
                desc: "Eco Mantra Capital provides professional support in handling client trading accounts using automated strategies, ensuring a simple, transparent, and stress-free experience.",
              },
              {
                title: "Joint Venture / Partnership Model",
                desc: "We collaborate with investors on a joint venture, offering algo trading systems and execution expertise. Investments remain under investor control and ownership, ensuring transparency and security.",
              },
              {
                title: "Venture Capital Approach",
                desc: "Eco Mantra Capital also operates with a venture‑style mindset, supporting clients with technology, strategy, and execution frameworks to scale trading operations efficiently and sustainably.",
              },
            ].map((service, index) => (
              <div className="col-xl-4 col-md-6 col-sm-12" key={index}>
                <div
                  className="service_block_one"
                  data-aos="fade-up"
                  data-aos-duration="500"
                  data-aos-delay={100 * (index + 1)}
                >
                  <h4 className="text-white">{service.title}</h4>
                  <p className="text-white">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Advantages Section */}
      <section className="about_section_three">
        <div className="container">
          <div className="row">
            {/* Left Image */}
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div
                className="about_left_image"
                data-aos="fade-right"
                data-aos-duration="500"
              >
                <figure>
                  <img
                    src="/images/resource/about-us-2.png"
                    alt="Key Advantages"
                    style={{ borderRadius: "10px" }}
                  />
                </figure>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div
                className="about_right_content"
                data-aos="fade-left"
                data-aos-duration="500"
              >
                <div
                  className="pricing_block_one text-left"
                  data-aos="fade-up"
                  data-aos-duration="500"
                  data-aos-delay="200"
                >
                  <div className="pricing_table" style={{ textAlign: "left" }}>
                    <div className="table_header">
                      <h2>Key Advantages</h2>
                    </div>
                    <div className="table_content">
                      <ul className="feature_list text-left">
                        <li className="Coverage-list">
                          <i className="fa-solid fa-check"></i>
                          <span>Emotion-free and disciplined trading</span>
                        </li>
                        <li className="Coverage-list">
                          <i className="fa-solid fa-check"></i>
                          <span>
                            Technology-driven execution with reduced human error
                          </span>
                        </li>
                        <li className="Coverage-list">
                          <i className="fa-solid fa-check"></i>
                          <span>
                            Customizable and scalable trading strategies
                          </span>
                        </li>
                        <li className="Coverage-list">
                          <i className="fa-solid fa-check"></i>
                          <span>
                            Transparent structure with investor fund control
                          </span>
                        </li>
                        <li className="Coverage-list">
                          <i className="fa-solid fa-check"></i>
                          <span>
                            Expertise in both local and global markets
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team_details_section pb_150">
        <div className="container">
          <div className="row align-items-center">
            {/* Team Image */}
            {/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="team_details_image">
                <img
                  src="/images/resource/team-details.jpg"
                  alt="Team Member"
                />
              </div>
            </div> */}

            {/* Author Content */}
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div className="author_content">
                <h3 className="author_name">BHARGAV CHAUHAN</h3>
                <span className="author_designation">
                  Founder & Proprietor – Shivom Financial
                </span>
                <p>
                  Financial Services | Fund Management | Capital Markets |
                  Global Investments
                </p>
                <div className="author_comment">
                  <p>
                    Mr. Bhargav Chauhan is a veteran financial services
                    professional with over 40 years of diversified experience
                    across cooperative finance, private equity, banking
                    distribution, real estate development, Indian capital
                    markets, portfolio management, and global forex trading.
                    Based in Mumbai, India, he combines deep grassroots
                    financial expertise with extensive international market
                    exposure, making him a trusted partner for investors,
                    institutions, and joint-venture associates.
                  </p>

                  <a href="founder-profile" className="btn_style_one">
                    Read More
                  </a>
                </div>
              </div>
            </div>

            {/* Author Information */}
            {/* <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
              <div className="author_information">
                <div className="author_info_title">Information</div>

                <div className="author_info_item">
                  <span>Location</span>
                  <h6>Dhaka, Bangladesh</h6>
                </div>

                <div className="author_info_item">
                  <span>Email</span>
                  <h6>brooklyn@example.com</h6>
                </div>

                <div className="author_info_item">
                  <span>Qualification</span>
                  <h6>Master in Computing</h6>
                </div>

                <div className="author_info_item">
                  <span>Gender</span>
                  <h6>Male</h6>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;
